import styled, {
  CSSProperties,
  FlattenSimpleInterpolation,
  css,
} from 'styled-components';
import { Media, Colors, FontFamilies } from 'enums';

export type TextTypeKinds =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'button'
  | 'body'
  | 'small1'
  | 'small2'
  | 'error';

type TextTypeKindsMap = { [key in TextTypeKinds]: FlattenSimpleInterpolation };

const typeKindsMobile: TextTypeKindsMap = {
  h1: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 600;
    font-size: 24px;
  `,
  h2: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
  `,
  h3: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 500;
    font-size: 18px;
  `,
  h4: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 600;
    font-size: 14px;
  `,
  button: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 500;
    font-size: 16px;
  `,
  body: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 400;
    font-size: 14px;
  `,
  error: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 600;
    font-size: 24px;
  `,
  small1: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 400;
    font-size: 10px;
  `,
  small2: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 500;
    font-size: 12px;
  `,
};

const typeKindsDesktop: TextTypeKindsMap = {
  h1: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 600;
    font-size: 40px;
  `,
  h2: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 500;
    font-size: 32px;
    line-height: 40px;
  `,
  h3: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 500;
    font-size: 28px;
  `,
  h4: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 600;
    font-size: 20px;
  `,
  button: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 500;
    font-size: 18px;
  `,
  body: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 400;
    font-size: 16px;
  `,
  error: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 500;
    font-size: 32px;
  `,
  small1: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 400;
    font-size: 14px;
  `,
  small2: css`
    font-family: ${FontFamilies.Inter};
    font-weight: 500;
    font-size: 14px;
  `,
};

const colors = {
  yellow1: Colors.yellow1,
  yellow2: Colors.yellow2,
  yellow3: Colors.yellow3,
  gray1: Colors.gray1,
  gray2: Colors.gray2,
  gray3: Colors.gray3,
  gray4: Colors.gray4,
  red1: Colors.red1,
  red2: Colors.red2,
  hover_links: Colors.hover_links,
  background: Colors.background,
  card: Colors.card,
  white: Colors.white,
  label_color: Colors.label_color,
};

export type ITypes = {
  kind: TextTypeKinds;
  color?: keyof typeof colors;
  length?: number;
  customStyles?: Partial<Record<'desktop' | 'mobile', CSSProperties>>;
};

export const Text = styled.p<ITypes>`
  margin: 0px;
  word-break: ${({ length }) => length && length > 6 && 'break-word'};
  color: ${({ color }) => (color ? colors[color] : Colors.gray1)};

  ${({ kind }) => typeKindsMobile[kind]}
  ${({ customStyles }) => customStyles?.mobile && { ...customStyles.mobile }}

  @media ${Media.notebook} {
    ${({ kind }) => typeKindsDesktop[kind]}
    ${({ customStyles }) =>
      customStyles?.desktop && { ...customStyles.desktop }}
  }
`;
